<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha"
            style="display: flex;  justify-content: center;  flex-direction: column; align-items: center;">
            <div v-if="mode === 'receptores'" style="display:contents;">
                <div class="clearfix">
                    <h2>Usuarios</h2>
                </div>
                <div style="width: 360px; margin-top: 50px; margin-bottom:20px;">
                    <div class="contenedorbusqueda">
                        <el-form label-position="top" label-width="100px" :status-icon="true"
                            style="margin-bottom: 10px;">
                            <el-input v-model="busqueda" placeholder="Escribe para buscar"></el-input>
                        </el-form>
                    </div>
                    <transition-group name="fade" tag="div" class="contenedorreceptores">
                        <p v-for="receptor in usuariosFiltrados" :key="receptor.id + receptor.tipo" class="usuario"
                            @click="usuarioSeleccionado = receptor; obtenerDocumentos(receptor.email)">
                            <img style="width: 30px; margin-left: 10px;" src="@/assets/usuario.png" />{{ receptor.nombre
                            }}
                            <small v-if="receptor.nombredep"><br>{{ receptor.nombredep }}</small>
                        </p>
                    </transition-group>
                    <el-button style="margin-top: 10px; width: 400px;" type="primary"
                        @click="$router.go(-1)">Volver</el-button>
                </div>
            </div>
            <div v-if="mode == 'verDocumentos'" style="display:contents;">
                <div class="clearfix">
                    <h2>Documentos</h2>
                    <h3>{{ usuarioSeleccionado.nombre }}</h3>
                </div>
                <div style="width: 360px; margin-top: 50px; margin-bottom:20px;">
                    <el-breadcrumb separator="/" style="font-size:1.1rem">
                        <el-breadcrumb-item key="tab9999">
                            <span style="cursor:pointer"
                                @click="navegacion.tabs.length === 0 ? mode = 'receptores' : (navegacion.indices.pop(), navegacion.tabs.pop())">
                                <font-awesome-icon :icon="['fas', 'chevron-left']" />
                            </span>
                        </el-breadcrumb-item>
                        <el-breadcrumb-item v-for="(tab, index) in navegacion.tabs" :key="tab + index">
                            <span style="cursor:pointer"
                                @click="navegacion.indices.splice(index + 1); navegacion.tabs.splice(index + 1)">
                                {{ tab }}
                            </span>
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div
                    :style="`width: 360px; height: 330px; border-radius: 5px; overflow-y:auto; overflow-x: hidden; align-items: start; display: flex; flex-direction: column;`">
                    <div v-for="(archivo, index) in filteredMisArchivos" :key="archivo.nombre + index">
                        <div :id="`dialog-content${index}`" style="display:none;max-width:500px;">
                            <h4><font-awesome-icon :icon="getIconPath(archivo.nombre)" /> {{ archivo.nombre }}</h4>
                            <div class="navigation_controls"
                                v-if="docprevisualizacion.pdf && docprevisualizacion.pdf._pdfInfo.numPages > 1"
                                style="width: 100%; margin-bottom:20px; display: flex; justify-content: space-between; align-items: center;">
                                <el-button @click="--docprevisualizacion.currentPage;" type="info"
                                    circle :disabled="docprevisualizacion.currentPage == 1"><font-awesome-icon :icon="['fas', 'angle-left']" /></el-button>
                                <span id="span_pagina" style="color:#727272;"><b>Página <span class="pagina_1">{{
        docprevisualizacion.currentPage }}</span>
                                        de <span>{{ docprevisualizacion.pdf._pdfInfo.numPages }}</span> </b></span>
                                <el-button @click="++docprevisualizacion.currentPage;" type="info"
                                    circle
                                    :disabled="docprevisualizacion.currentPage == docprevisualizacion.pdf._pdfInfo.numPages"><font-awesome-icon :icon="['fas', 'angle-right']" /></el-button>
                            </div>
                            <center>
                                <img v-if="docprevisualizacion.pages && docprevisualizacion.pages[docprevisualizacion.currentPage - 1]"
                                    ref="img_0" id="img_0" class="img_0"
                                    style="width: 100%; border:3px solid darkgray; border-radius:5px; height: 500px"
                                    :src="docprevisualizacion.pages[docprevisualizacion.currentPage - 1].data ?? ''">
                            </center>
                            <div style="display:flex; margin-top: 10px;">
                                <el-button
                                    v-if="datos.permisos.borrar && navegacion.tabs && navegacion.tabs[navegacion.tabs.length - 1] == 'Pendientes de firma'"
                                    @click="eliminarArchivo(archivo)" type="danger" style="width: 100%"
                                    plain><font-awesome-icon :icon="['fas', 'trash']" /> Eliminar</el-button>
                                <el-button @click="descargarArchivo(archivo)" type="success" style="width: 100%"
                                    plain><font-awesome-icon :icon="['fas', 'cloud-arrow-down']" />
                                    Descargar</el-button>
                            </div>
                        </div>
                        <div v-if="!selectorzip" data-fancybox :data-src="`#dialog-content${index}`"
                            class="documento" style="transition:none; text-overflow: ellipsis; overflow: hidden;"
                            @click="archivo.tipo == 'carpeta' ? navegacion.indices.push(index) && navegacion.tabs.push(archivo.nombre) : previsualizacion(archivo);">
                            <font-awesome-icon style="color: #f39c12;" v-if="archivo.tipo == 'carpeta'"
                                :icon="['fas', 'folder']" /><font-awesome-icon
                                v-if="archivo.tipo != 'carpeta' && !archivo.certificado"
                                :icon="getIconPath(archivo.nombre)" />
                            <font-awesome-icon v-if="archivo.tipo != 'carpeta' && archivo.certificado"
                                style="color: #67C23A" :icon="['fas', 'check']" />
                            {{ archivo.nombre }}
                        </div>
                        <div v-if="archivo.tipo != 'carpeta' && selectorzip" class="documento"><el-switch
                                v-if="archivo.tipo != 'carpeta' && selectorzip" v-model="archivo.seleccionado"
                                active-color="#13ce66" inactive-color="#ff4949">
                            </el-switch> {{ archivo.nombre }}</div>
                    </div>
                    <el-empty style="margin: auto;" v-if="filteredMisArchivos.length == 0"
                        :image="require('@/assets/new/caja-vacia.png')"
                        description="No se han encontrado documentos"></el-empty>
                </div>
                <el-button @click="selectorzip = true" v-if="this.navegacion.indices.length > 0 && selectorzip == false"
                    style="width: 100%; margin: 10px 0px;" type="primary" plain><font-awesome-icon
                        :icon="['fas', 'file-zipper']" style="margin-right: 5px;" />Crear ZIP</el-button>
                <el-button @click="descargarSeleccion()"
                    v-if="this.navegacion.indices.length > 0 && selectorzip == true"
                    style="width: 100%; margin: 5px 0px;" type="primary" plain><font-awesome-icon
                        :icon="['fas', 'download']" style="margin-right: 5px;"/>
                    Descargar</el-button>
                <el-button @click="selectorzip = false" @click.stop
                    v-if="this.navegacion.indices.length > 0 && selectorzip == true"
                    style="width: 100%; margin: 5px 0px;" type="danger" plain><font-awesome-icon
                        :icon="['fas', 'file-zipper']" style="margin-right: 5px;" />
                    Cancelar</el-button>
                <template v-if="datos.permisos.subir && this.navegacion.indices.length > 0 && selectorzip == false">
                    <el-button style="width: 100%; margin:0px;" data-fancybox :data-src="`#subirDocumentosModal`"
                        type="success" plain><font-awesome-icon :icon="['fas', 'cloud-arrow-up']" style="margin-right: 5px;" /> Subir
                        documentos</el-button>
                    <div :id="`subirDocumentosModal`" style="display:none;max-width:500px;">
                        <input id="fileUpload" type="file" name="archivo" aria-label="Archivo" hidden multiple
                            @change="handleFileUpload">
                        <span id="dropZone" @click="solicitarArchivo" v-on:dragover="handleDragOver"
                            v-on:dragleave="dragover = ''" v-on:drop="handleFileUpload"
                            :style="`margin-top: 0px; height: ${300 - (33 * file.length)}px; min-height:165px; transition: 0.5s`"
                            :class="`solicitarArchivo ${dragover} ${shake ? 'apply-shake' : ''}`">
                            <i v-if="!shake" :class="`${dragover != '' ? 'el-icon-success' : 'el-icon-upload'}`"></i>
                            <i v-else class="el-icon-error"></i>
                            <div class="el-upload__text">Suelta tus archivos aquí o <em
                                    :style="`font-style: normal; color: #67c23a; ${shake ? 'color: #F56C6C;' : ''} transition: 0.5s;`">haz
                                    clic para cargar</em></div>
                            <div class="el-upload__tip">Solo archivos con un tamaño menor a 20 MB</div>
                        </span>
                        <div
                            :style="`width: 360px; height: ${0 + (33 * file.length)}px; max-height: 135px; overflow-y: hidden; border-radius: 5px; margin: 10px 0px 0px 0px; transition: 0.5s; ${file.length > 4 ? 'background: #d3d3d357; overflow-y:scroll;' : ''}`">
                            <el-tag v-for="(archivo, index) in file" :key="archivo.file.name"
                                @click="file.splice(index, 1); documentos.splice(index, 1)" class="documento">
                                <font-awesome-icon :icon="getIconPath(archivo.file.name)" />
                                {{ archivo.file.name }}
                            </el-tag>
                        </div>
                        <el-button @click="subirArchivos" style="width: 100%; margin-top: 10px;" type="success" plain>
                            <font-awesome-icon :icon="['fas', 'cloud-arrow-up']" /> Subir
                        </el-button>
                    </div>
                </template>
            </div>
        </div>
    </el-col>
</template>

<script>
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import download from "downloadjs";
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
export default {
    name: 'DocumentosUsuarios',
    data() {
        return {
            loading: true,
            navegacion: {
                indices: [],
                tabs: []
            },
            mode: 'receptores',
            misArchivos: [],
            busqueda: '',
            usuarioSeleccionado: {},
            docprevisualizacion: {},
            cargando: false,
            documentos: [],
            file: [],
            dragover: '',
            shake: false,
            selectorzip: false,
        }
    },
    mounted() {
        Fancybox.bind("[data-fancybox]", {
            // Your custom options
        });
        navigator.vibrate(200);
    },
    watch: {
        numIndices() {
            this.selectorzip = false;
            this.obtenerDocumentos(this.usuarioSeleccionado.email);
        }
    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'files', 'datos'
        ]),
        numIndices() {
            return this.navegacion.indices.length;
        },
        filteredMisArchivos() {
            let resultado = this.misArchivos;
            for (let i = 0; i < this.navegacion.indices.length; i++) {
                let indice = this.navegacion.indices[i];

                if (Object.prototype.hasOwnProperty.call(resultado, indice)) {
                    resultado = resultado[indice]['contenido'];
                } else {
                    resultado = null;
                    break;
                }
            }
            return resultado;
        },
        usuarios() {
            let receptores = [...this.receptores];
            return receptores.filter((receptor) => { return receptor.tipo == 'empleado' });
        },
        usuariosFiltrados() {
            if (this.busqueda && this.busqueda != '') {
                return this.usuarios.filter((usuario) => { return usuario.nombre.toLowerCase().includes(this.busqueda.toLowerCase()) })
            }
            return this.usuarios
        }
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores'
        ]),
        shakeAnimation() {
            this.shake = true;
            setTimeout(() => {
                this.shake = false;
            }, 820); // timeout value depending on the duration of the animation
        },
        handleDragOver(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            evt.dataTransfer.dropEffect = 'copy';
            this.dragover = 'dragover';
        },
        solicitarArchivo() {
            document.getElementById('fileUpload').click();
        },
        async handleFileUpload(event) {
            event.stopPropagation();
            event.preventDefault();
            const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
            this.dragover = '';
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (file.size <= 20971520) {
                    console.log(file);
                    let fileObj = {
                        file: file,
                        icon: 'document',
                        tipo: 'info',
                        coorx: null,
                        coory: null
                    };
                    let isDuplicate = this.file.some(filtrado => {
                        return filtrado.file.name === fileObj.file.name && filtrado.file.size === fileObj.file.size && filtrado.file.type === fileObj.file.type;
                    });

                    if (!isDuplicate) {
                        this.file.unshift(fileObj);
                    } else {
                        this.$message.error('Este archivo ya ha sido subido.');
                        this.shakeAnimation();
                    }

                } else {
                    this.$message.error('El tamaño del archivo excede el límite.');
                    this.shakeAnimation();
                }
            }

            event.target.value = '';

        },
        async previsualizacion(archivo) {
            this.cargando = true;
            this.docprevisualizacion = {};
            let desglose = archivo.nombre.split('.');
            let response = await fetch(process.env.VUE_APP_PORTAL + ':8004/api/descargarDocumento', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ruta: archivo.ruta })
            });

            let blob = await response.blob();
            let url = await this.blobToDataURL(blob);
            blob = await this.blobToBinary(blob);
            switch (desglose[desglose.length - 1]) {
                case 'pdf':
                    break;
                case 'png':
                case 'jpg':
                case 'gif':
                case 'jpeg':
                case 'tif':
                case 'tiff':
                case 'bmp':
                    this.docprevisualizacion = {
                        currentPage: 1,
                        pages: [
                            {
                                data: url
                            }
                        ],
                        pdf: {
                            _pdfInfo: {
                                numPages: 1
                            }
                        }
                    };
                    return;
                default:
                    return;
            }
            let pdfjsLib = window["pdfjs-dist/build/pdf"];
            const loadingTask = pdfjsLib.getDocument({ data: blob });
            let pdf = await loadingTask.promise;

            this.docprevisualizacion = {
                pdf: pdf,
                currentPage: 1,
                pages: [],
                pdfData: blob,
                eventClickImg: null,
                data: {
                    valid: false,
                    idioma: 'es'
                }
            };

            await this.procesarPages();
            this.cargando = false;
        },

        async procesarPages() {
            const scale = 4;
            let documento = this.docprevisualizacion;

            for (let i = 1; i <= documento.pdf.numPages; i++) {
                let page = await documento.pdf.getPage(i);
                const viewport = page.getViewport({ scale });

                let canvas = document.createElement('canvas');
                let canvasContext = canvas.getContext("2d");
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                let renderTask = page.render({ canvasContext, viewport });
                await renderTask.promise;

                // Convertir el contenido del canvas a base64
                let imageData = canvas.toDataURL("image/jpeg");

                documento.pages.push({
                    page: i,
                    data: imageData,
                    cuadros: [],
                });
            }
        },
        async blobToDataURL(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        async blobToBinary(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onloadend = () => {
                    // El resultado es un ArrayBuffer que representa los datos binarios del Blob
                    resolve(reader.result);
                };

                reader.onerror = reject;

                // Leer el Blob como ArrayBuffer
                reader.readAsArrayBuffer(blob);
            });
        },
        async subirArchivos() {
            const formData = new FormData();
            this.file.forEach((file, index) => {
                formData.append('file' + index, file.file);
            })
            formData.append('ruta', this.misArchivos[this.navegacion.indices[this.navegacion.indices.length - 1]].ruta);
            try {
                let response = await fetch(process.env.VUE_APP_PORTAL + ':8004/api/subirDocumento', {
                    method: 'POST',
                    body: formData
                });
                if (response.status == 200) {
                    this.$notify({
                        title: '¡Bien!',
                        message: 'Archivos subidos correctamente',
                        type: 'success'
                    });
                    this.file = [];
                    this.obtenerDocumentos(this.usuarioSeleccionado.email)
                } else {
                    console.error('Error downloading file:', response.status, response.statusText);
                }
            } catch (error) {
                console.error('An unexpected error occurred during file download:', error);
            }
        },
        async descargarArchivo(archivo) {
            Fancybox.close();
            try {
                let response = await fetch(process.env.VUE_APP_PORTAL + ':8004/api/descargarDocumento', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ ruta: archivo.ruta })
                });

                if (response.ok) {
                    // Utilizar blob() para obtener un objeto Blob
                    let blob = await response.blob();

                    // Utilizar download.js para descargar el archivo
                    download(blob, archivo.nombre);
                } else {
                    console.error('Error downloading file:', response.status, response.statusText);
                }
            } catch (error) {
                console.error('An unexpected error occurred during file download:', error);
            }
        },
        async descargarSeleccion() {
            try {
                let response = await fetch(process.env.VUE_APP_PORTAL + ':8004/api/descargarDocsZip', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ archivos: this.filteredMisArchivos })
                });

                if (response.ok) {
                    // Utilizar blob() para obtener un objeto Blob
                    let blob = await response.blob();

                    // Utilizar download.js para descargar el archivo
                    download(blob, 'descarga.zip');
                    this.selectorzip = false;
                    this.obtenerDocumentos(this.usuarioSeleccionado.email);
                } else {
                    console.error('Error downloading file:', response.status, response.statusText);
                }
            } catch (error) {
                console.error('An unexpected error occurred during file download:', error);
            }
        },
        async eliminarArchivo(archivo) {
            Fancybox.close();
            try {
                let response = await fetch(process.env.VUE_APP_PORTAL + ':8004/api/eliminarDocumento', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ ruta: archivo.ruta })
                });
                this.obtenerDocumentos(this.usuarioSeleccionado.email);
                console.log(response);
            } catch (error) {
                console.error('An unexpected error occurred during file download:', error);
            }
        },
        async obtenerDocumentos(email) {
            let response = await fetch(process.env.VUE_APP_PORTAL + '/api/documentos/obtenerDocumentosUsuario', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify({ email: email ?? this.datosemp.mail })
            });
            if (response.status == 200) {
                response = await response.json();
                this.misArchivos = response;
                this.mode = 'verDocumentos';
            }
        },
        volver() {
            this.$emit('volver');
        },
        getIconPath(nombreArchivo) {
            let img = '';
            let ext = nombreArchivo.split('.').pop();
            switch (ext) {
                case 'ico':
                case 'gif':
                case 'jpg':
                case 'jpeg':
                case 'jpc':
                case 'jp2':
                case 'jpx':
                case 'xbm':
                case 'wbmp':
                case 'png':
                case 'bmp':
                case 'tif':
                case 'tiff':
                case 'webp':
                case 'avif':
                case 'svg':
                    img = 'fa-regular fa-image';
                    break;
                case 'passwd':
                case 'ftpquota':
                case 'sql':
                case 'js':
                case 'json':
                case 'sh':
                case 'config':
                case 'twig':
                case 'tpl':
                case 'md':
                case 'gitignore':
                case 'c':
                case 'cpp':
                case 'cs':
                case 'py':
                case 'rs':
                case 'map':
                case 'lock':
                case 'dtd':
                    img = 'fa-regular fa-file-code';
                    break;
                case 'txt':
                case 'ini':
                case 'conf':
                case 'log':
                case 'htaccess':
                case 'yaml':
                case 'yml':
                case 'toml':
                    img = 'fa-regular fa-file-lines';
                    break;
                case 'css':
                case 'less':
                case 'sass':
                case 'scss':
                    img = 'fa-brands fa-css3-alt';
                    break;
                case 'bz2':
                case 'zip':
                case 'rar':
                case 'gz':
                case 'tar':
                case '7z':
                case 'xz':
                    img = 'fa-regular fa-file-zipper';
                    break;
                case 'php':
                case 'php4':
                case 'php5':
                case 'phps':
                case 'phtml':
                    img = 'fa-solid fa-code';
                    break;
                case 'htm':
                case 'html':
                case 'shtml':
                case 'xhtml':
                    img = 'fa-brands fa-html5';
                    break;
                case 'xml':
                case 'xsl':
                    img = 'fa-regular fa-file-excel';
                    break;
                case 'wav':
                case 'mp3':
                case 'mp2':
                case 'm4a':
                case 'aac':
                case 'ogg':
                case 'oga':
                case 'wma':
                case 'mka':
                case 'flac':
                case 'ac3':
                case 'tds':
                    img = 'fa-solid fa-music';
                    break;
                case 'm3u':
                case 'm3u8':
                case 'pls':
                case 'cue':
                case 'xspf':
                    img = 'fa-solid fa-headphones';
                    break;
                case 'avi':
                case 'mpg':
                case 'mpeg':
                case 'mp4':
                case 'm4v':
                case 'flv':
                case 'f4v':
                case 'ogm':
                case 'ogv':
                case 'mov':
                case 'mkv':
                case '3gp':
                case 'asf':
                case 'wmv':
                case 'webm':
                    img = 'fa-regular fa-file-video';
                    break;
                case 'eml':
                case 'msg':
                    img = 'fa-regular fa-envelope';
                    break;
                case 'xls':
                case 'xlsx':
                case 'ods':
                    img = 'fa-regular fa-file-excel';
                    break;
                case 'csv':
                    img = 'fa-regular fa-file-lines';
                    break;
                case 'bak':
                case 'swp':
                    img = 'fa-regular fa-clipboard';
                    break;
                case 'doc':
                case 'docx':
                case 'odt':
                    img = 'fa-regular fa-file-word';
                    break;
                case 'ppt':
                case 'pptx':
                    img = 'fa-regular fa-file-powerpoint';
                    break;
                case 'ttf':
                case 'ttc':
                case 'otf':
                case 'woff':
                case 'woff2':
                case 'eot':
                case 'fon':
                    img = 'fa-solid fa-font';
                    break;
                case 'pdf':
                    img = 'fa-regular fa-file-pdf';
                    break;
                case 'psd':
                case 'ai':
                case 'eps':
                case 'fla':
                case 'swf':
                    img = 'fa-regular fa-file-image';
                    break;
                case 'exe':
                case 'msi':
                    img = 'fa-regular fa-file';
                    break;
                case 'bat':
                    img = 'fa-solid fa-terminal';
                    break;
                default:
                    img = 'fa-solid fa-circle-info';
                    break;
            }
            return img;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#colderecha {
    * {
        max-width: 360px;
    }
}

.fancybox-bg {
    background: #888;
}

.fancybox-is-open .fancybox-bg {
    opacity: 1;
}

.documento {
    padding: 0 10px;
    line-height: 30px;
    font-size: 1rem;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
    height: auto;
    border: none;
    background: none;
    color: dimgray;
    text-align: left;

    &.success {
        color: #67C23A;
    }

    &.error {
        color: #f56c6c;
    }
}

.usuario {
    border: 2px solid #0984e3;
    padding: 15px;
    border-radius: 10px;
    color: #0984e3;
    background-color: #0985e31f;
    font-weight: bold;
    margin: 10px;
    transition: 0.5s;
    display: flex;
    align-items: center;

    &:hover {
        background-color: #6dff4005;
    }

    img {
        margin-right: 10px;
    }
}

ul {
    padding-left: 0px;
    padding: 10px;
}

li {
    list-style: none;
    margin: 5px 0px;
}

.contenedorreceptores {
    @media(min-width: 480px) {
        width: 400px;
    }

    height: 50vh;
    overflow-y:auto;
}

.contenedorbusqueda {
    @media(min-width: 480px) {
        width: 400px;
    }
}

.documento {
    padding: 0 10px;
    line-height: 30px;
    font-size: 1rem;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
    height: auto;
    border: none;
    background: none;
    color: dimgray;
    text-align: left;

    &.success {
        color: #67C23A;
    }

    &.error {
        color: #f56c6c;
    }
}

.solicitarArchivo {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    margin: 50px 0 0 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    &.dragover {
        border-color: #0984e3;

        svg {
            color: #0984e3;
        }
    }

    &.apply-shake {
        border-color: #d63031;

        svg {
            color: #d63031;
        }
    }

    svg {
        font-size: 67px;
        color: #C0C4CC;
        line-height: 50px;
        margin-bottom: 10px;
        transition: 0.5s;
    }
}

.el-tag {
    span {
        text-overflow: ellipsis!important;
        overflow: hidden!important;
    }
}
</style>